(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abide-order-tracking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let loader;
    function loadTracker() {
      if (window.YQV5?.trackSingle) return Promise.resolve();
      if (loader) return loader;
      loader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const finish = (error) => {
          clearTimeout(timer);
          script.onload = script.onerror = null;
          if (error) { script.remove(); reject(error); } else resolve();
        };
        const timer = setTimeout(() => finish(new Error('timeout')), 12000);
        script.src = 'https://www.17track.net/externalcall.js';
        script.async = true;
        script.onload = () => finish(window.YQV5?.trackSingle ? null : new Error('unavailable'));
        script.onerror = () => finish(new Error('network'));
        document.head.append(script);
      }).catch(error => { loader = undefined; throw error; });
      return loader;
    }
    class AbideOrderTracking extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.input = this.querySelector('input');
        this.button = this.querySelector('button');
        this.status = this.querySelector('[data-status]');
        this.results = this.querySelector('[data-results]');
        this.button.disabled = false;
        this.querySelector('form').addEventListener('submit', event => this.submit(event), { signal: this.controller.signal });
        this.input.addEventListener('input', () => this.input.setCustomValidity(''), { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async submit(event) {
        event.preventDefault();
        if (this.button.disabled) return;
        const number = this.input.value.trim();
        if (!number || number.length > 50) {
          this.input.setCustomValidity(this.dataset.invalid);
          this.input.reportValidity();
          return;
        }
        this.button.disabled = true;
        this.status.textContent = this.dataset.loading;
        const signal = this.controller.signal;
        try {
          await loadTracker();
          if (signal.aborted) return;
          this.results.replaceChildren();
          window.YQV5.trackSingle({ YQ_ContainerId: this.results.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: number });
          this.status.textContent = this.dataset.opened;
        } catch {
          if (!signal.aborted) this.status.textContent = this.dataset.error;
        } finally {
          if (!signal.aborted) this.button.disabled = false;
        }
      }
    }
    if (!customElements.get('abide-order-tracking')) customElements.define('abide-order-tracking', AbideOrderTracking);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abide-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('abide-slider-component')) {
  customElements.define('abide-slider-component', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slider = this.querySelector('.abide-slider-list');
      this.dotsContainer = this.querySelector('.abide-slider-dots');
      if (!this.slider || !this.dotsContainer) return;
      this.slides = [...this.slider.children];
      this.index = 0;
      this.dotsContainer.replaceChildren();
      this.dots = this.slides.map((slide,index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'abide-slider-dot';
        dot.setAttribute('aria-label', (this.dataset.slideLabel || 'Slide') + ' ' + (index + 1));
        dot.addEventListener('click', () => this.go(index), {signal});
        this.dotsContainer.append(dot);
        return dot;
      });
      this.querySelector('.prev-button')?.addEventListener('click', () => this.go(this.index-1), {signal});
      this.querySelector('.next-button')?.addEventListener('click', () => this.go(this.index+1), {signal});
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key) || event.target.matches('input,textarea,select')) return;
        event.preventDefault();this.go(this.index + (event.key==='ArrowRight'?1:-1));
      }, {signal});
      this.slider.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const left=this.slider.getBoundingClientRect().left;
          let closest=0,distance=Infinity;
          this.slides.forEach((slide,i) => {const d=Math.abs(slide.getBoundingClientRect().left-left);if(d<distance){distance=d;closest=i;}});
          this.index=closest;this.update();
        });
      }, {signal,passive:true});
      this.update();
    }
    go(index) {
      if (!this.slides.length) return;
      this.index=(index+this.slides.length)%this.slides.length;
      const slide=this.slides[this.index];
      const left=slide.getBoundingClientRect().left-this.slider.getBoundingClientRect().left+this.slider.scrollLeft;
      this.slider.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      this.update();
    }
    update() {this.dots.forEach((dot,i)=>{dot.classList.toggle('active',i===this.index);dot.setAttribute('aria-current',i===this.index?'true':'false');});}
    disconnectedCallback(){this.controller?.abort();if(this.frame)cancelAnimationFrame(this.frame);this.frame=0;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abide-statistics"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('abide-statistics')) {
  customElements.define('abide-statistics', class extends HTMLElement {
    connectedCallback() {
      this.frames = new Set();
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.observer.unobserve(entry.target);
          const target = Number(entry.target.dataset.target);
          const suffix = entry.target.dataset.suffix || '';
          const start = performance.now();
          const update = time => {
            if (!this.isConnected) return;
            const progress = Math.min((time - start) / 1200, 1);
            entry.target.textContent = Math.round(target * (1 - (1 - progress) ** 3)) + suffix;
            if (progress < 1) schedule(update);
          };
          const schedule = callback => {
            const id = requestAnimationFrame(time => { this.frames.delete(id); callback(time); });
            this.frames.add(id);
          };
          schedule(update);
        }
      }, {threshold:0.35});
      this.querySelectorAll('.abide-number-counter').forEach(el => this.observer.observe(el));
    }
    disconnectedCallback() { this.observer?.disconnect(); this.frames?.forEach(cancelAnimationFrame); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
